import { asPage } from 'src/components/hoc/asPage'
import { Needs } from 'src/compositions/Needs'

export default asPage(Needs, { pageTitle: '決裁者を探す' })
